// For now we can't re-export json using TS and JSON import has no default
import _breakpoints from "./breakpoints.json"
import _containedIconColors from "./containedIconColors.json"
import _countries from "./countries.json"
import _icons from "./icons.json"
import _palette from "./palette.json"
import _theme from "./theme.json"
import _zIndexes from "./zIndexes.json"

export const breakpoints = _breakpoints
export const containedIconColors = _containedIconColors
export const countries = _countries
export const icons = _icons
export const zIndexes = _zIndexes
export const palette = _palette
export const theme = _theme
